import React, { memo } from "react";
import {
  Select,
  MenuItem,
  FormControl,
  FormHelperText,
  InputLabel,
  makeStyles,
} from "@material-ui/core";

import {
  Controller,
  useFormContext,
  useController,
  get,
} from "react-hook-form";
import Error from "../Error/Error";
import ArrowDown from "../../assets/img/arrow-down-2.svg";
import { white } from "../../constants/colors";

const useStyles = makeStyles(({ breakpoints: { down } }) => ({
  selectStyles: {
    marginBottom: "10px",
    width: "100%",

    "&.MuiOutlinedInput-root.Mui-error": {
      borderColor: "none",
    },

    "& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline": {
      borderColor: "#D7D7D7",
    },

    "& .MuiInputLabel-shrink": {
      transform: "translate(14px, 9px) scale(0.75)",
    },

    "& label": {
      paddingLeft: "15px",
      zIndex: 1,
      marginTop: "-3px",
      [down("sm")]: {
        pointerEvents: "none",
      },
    },

    "& label.Mui-focused, & label.MuiFormLabel-filled": {
      paddingLeft: 0,
      fontSize: "12px",
      marginTop: 0,
    },

    "& .MuiInputBase-root:hover": {
      "& fieldset": {
        borderColor: "#111E26 !important",
      },
    },

    "& .MuiOutlinedInput-input": {
      padding: "20px 15px",
      fontFamily: "sbcBold",
      zIndex: 1,
    },

    "& .MuiFormLabel-root.Mui-error": {
      color: "#666666",
    },

    "& .MuiInputBase-root": {
      height: "62px",

      "& img": {
        right: "20px",
        top: "initial",
        zIndex: 1
      },

      "& input": {
        fontFamily: "sbcBold",
        color: "#282F36",
        fontSize: "16px",
        lineHeight: 1.2,
        marginTop: "10px",
        zIndex: 1,
      },
      "& fieldset": {
        border: "1px solid #D7D7D7",
        borderRadius: "10px",
        top: 0,
        background: white,

        "& legend": {
          display: "none",
        },
      },
    },
  },
}));

const CustomSelect = ({ ...props }) => {
  const { selectStyles } = useStyles();
  const { meta } = useController(props);
  const { control, formState } = useFormContext();
  const error = get(formState.errors, props.name);
  const errorText = meta.invalid ? error.message : "";

  return (
    <FormControl error={!!errorText} className={selectStyles}>
      <InputLabel id="demo-simple-select-label">{props.label}</InputLabel>
      <Controller
        {...props}
        as={
          <Select
            IconComponent={() => (
              <img
                src={ArrowDown}
                alt="arrow-down"
                className="MuiSelect-icon"
              />
            )}
          >
            {props.location !== "billing" && props.location !== "gender" && !props.withoutEmpty && (
              <MenuItem value="">None</MenuItem>
            )}

            {props.options.map((option, index) => (
              <MenuItem value={option.value} key={index}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
        }
        variant="outlined"
        control={control}
        defaultValue={props.defaultValue}
      />

      <FormHelperText>
        {errorText && <Error errorMessage={errorText} />}
        {/* {errorText ? errorText : props.helperText} */}
      </FormHelperText>
    </FormControl>
  );
};

export default memo(CustomSelect);
